export default "__VITE_ASSET__CJDi3djN__"